import React from "react";
import styled from "styled-components";
import PremiumSummaryCard from "../../common/premium/PremiumSummaryCard";
import PremiumWarehouseSelector from "../../common/premium/PremiumWarehouseSelector";
import { posDisplayName } from "./ordersComponents/checkReport";

// Only this Orders adapter wraps long CHECK labels; other summary cards retain their styling.
const CheckSummary = styled(PremiumSummaryCard)`
    .summary-update-line dt { white-space: normal; overflow: visible; text-overflow: clip; overflow-wrap: anywhere; }
`;

/**
 * Orders v14 presentation adapter. Inputs are display-ready, not raw backend records.
 * The existing v13 warehouse dropdown remains a disabled visual placeholder only.
 * Preserve each page's existing selection, permissions, confirmations and EXPORT callback.
 * Five actions use the owner-approved two-row layout, including the new CHECK slot.
 */
export default function PremiumOrderSummaryCard({ order = {}, media, emptyCard = false,
    loading = false, selected = false, onSelectedChange, actions = {}, statusAdornment, locked = false, className }) {
    const state = loading ? "loading" : emptyCard ? "empty" : "ready";
    const fields = [
        { key: "brand", label: "From brand", value: order.brand },
        { key: "store", label: "To store", value: order.store },
        { key: "date", label: "Imported on", value: order.date },
        { key: "season", label: "Brand season", value: order.season }
    ];
    const metrics = [
        { key: "items", label: "Total items", value: order.totalItems, valueTone: "accent" },
        { key: "total", label: "Total", value: order.formattedTotal, valueTone: "accent" }
    ];
    const cardActions = [
        { key: "delete", label: "Delete", ...actions.delete, row: 0 },
        { key: "check", label: "Check", ...actions.check, row: 0 },
        { key: "rules", label: "Rules", ...actions.rules, row: 0 },
        { key: "view", label: "View", ...actions.view, row: 1 },
        { key: "export", label: "Export", emphasis: true, ...actions.export, row: 1 }
    ];
    return <CheckSummary title="Order summary" state={state} className={className}
        heading={order.number ? `Order: ${order.number}` : "--"} identifier={order.botagId}
        media={media} fields={fields} metrics={metrics} actions={cardActions} locked={locked} statusPlacement="details"
        ordersLayout updateRow={{ label: `Items to update in ${posDisplayName(order)}`,
            value: order.itemsToUpdate ?? "-", valueTone: "accent" }}
        controls={<PremiumWarehouseSelector />}
        status={{ value: order.status ?? "Unknown", label: order.status ?? "Unknown", colorClass: order.statusColorClass, adornment: statusAdornment }}
        selectable selected={selected} onSelectedChange={onSelectedChange}
        selectionLabel={`Select order ${order.number ?? ""}`.trim()} />;
}
